export default __webpack_public_path__ + "76750c85d5578914e66e62f9ec1498f3.png";